import { isObject, isValidHost } from '../utils/util';
var Ctx = /** @class */ (function () {
    function Ctx() {
        this.globalParams = {
            sdkVersion: '1.0.0',
            version: 'v1',
            /** 若用户 init 传了 isDev，则会被修改 */
            os: 'android',
        };
        this.isDebug = false;
        this.ignoreStorageError = false;
        this.isSankuaiOnly = false;
        /** host */
        this.host = null;
    }
    Ctx.prototype.init = function (params, options) {
        // 根据用户 params 修改 globalParams
        // 如果用户指定了 os 则更改 os
        if (params.os === 'ios') {
            this.globalParams.os = 'ios';
        }
        // 根据 options 修改 globalParams
        // 统一固定为 android 或 android_test
        if (options.isDev) {
            this.globalParams.os = this.globalParams.os === 'ios' ? 'ios_test' : 'android_test';
        }
        this.globalParams = Object.assign({}, params, this.globalParams);
        // 根据 option 设置 ctx
        this.isDebug = options.isDev;
        this.ignoreStorageError = options.ignoreStorageError;
        this.isSankuaiOnly = options.sankuaiOnly;
        if (options.host) {
            if (typeof options.host === 'string' && isValidHost(options.host)) {
                this.host = options.host;
            }
            else {
                throw new Error('[Horn] 指定 host 时需传人正确的 Host。e.g. http(s)://www.meituan.com');
            }
        }
        // 如果仅内网和 host 同时设置，以仅内网为准
        if (this.isSankuaiOnly && this.host) {
            // DEV 环境在控制台输出警告
            if (options.isDev) {
                console.warn('[Horn] sankuaiOnly 将指定使用内网域名，传人 host 不生效');
            }
        }
    };
    Ctx.prototype.setParams = function (params) {
        if (!isObject(params)) {
            return false;
        }
        Object.assign(this.globalParams, params);
    };
    return Ctx;
}());
export default Ctx;
//# sourceMappingURL=context.js.map